/*
 * Elegance Hero Slider — interactive navigation (variable per-slide durations).
 * Out of the box the slider is a pure-CSS keyframe carousel, so it autoplays with no JS
 * and inside the theme editor. This progressively enhances it: tapping a progress segment,
 * a tab, or a prev/next arrow — or swiping on mobile — hands control over to JS, which
 * from then on sets the active slide with a class and runs autoplay on a timer.
 * See the "Manual mode" note below for why it does not seek the CSS timeline instead.
 */
(function () {
  function init(root) {
    if (root.__heroSeekInit) return;
    root.__heroSeekInit = true;

    var raw = (root.getAttribute('data-hero-durations') || '').split(',');
    var durs = [];
    for (var d = 0; d < raw.length; d++) {
      var v = parseFloat(raw[d]);
      if (!isNaN(v) && v > 0) durs.push(v);
    }
    if (durs.length < 2) return;

    var totalSec = 0;
    for (var s = 0; s < durs.length; s++) totalSec += durs[s];

    // Works out which slide the CSS timeline is showing right now, so the FIRST tap knows
    // where to go next. Only needed before manual mode takes over — the CSS animation
    // starts at page load with a zero offset, so logical position = elapsed time (mod total).
    var lastRealTime = (window.performance && performance.now) ? performance.now() : Date.now();
    var lastLogicalTime = 0;

    function now() {
      return (window.performance && performance.now) ? performance.now() : Date.now();
    }

    function currentIndexNow() {
      var elapsed = (now() - lastRealTime) / 1000;
      var logical = (lastLogicalTime + elapsed) % totalSec;
      if (logical < 0) logical += totalSec;
      var running = 0;
      for (var i = 0; i < durs.length; i++) {
        running += durs[i];
        if (logical < running) return i;
      }
      return durs.length - 1;
    }

    // ---- Manual mode -------------------------------------------------------------------
    // Until the visitor interacts, the slider is a pure-CSS keyframe carousel (works with
    // no JS and in the theme editor). The moment they tap an arrow/tab or swipe, we switch
    // to manual mode: JS owns the active slide via an .is-active class and owns autoplay
    // via a timer, and the CSS kills every keyframe animation.
    //
    // The previous approach — seeking the shared keyframe timeline with a negative
    // animation-delay — was the bug behind "the arrows do nothing on mobile". Seeking puts
    // the playhead exactly on a keyframe boundary where the OUTGOING slide is still at its
    // end keyframe (opacity 1) and the INCOMING slide has reached its start keyframe
    // (opacity 1), so both are opaque and stacked. Confirmed live: after a seek both
    // slide 0 and slide 1 computed to opacity:1 / z-index:1 and stayed there. Manual mode
    // has no such ambiguity — exactly one slide is opaque, and it needs no animation clock.
    var manualIndex = -1;
    var autoTimer = null;

    function slideEls() { return root.querySelectorAll('.hero-slider__slide'); }
    function fillEls() { return root.querySelectorAll('.hero-slider__fill'); }
    function tabEls() { return root.querySelectorAll('.hero-slider__tab'); }

    function setActive(list, k) {
      for (var i = 0; i < list.length; i++) {
        if (i === k) list[i].classList.add('is-active');
        else list[i].classList.remove('is-active');
      }
    }

    // Progress bar in manual mode: the keyframes are off, so drive the active segment with
    // a plain transition over that slide's duration. Reset to 0 without a transition first,
    // force a reflow, then transition to 1 — otherwise the browser coalesces both changes
    // and the bar just snaps to full.
    function runFill(k) {
      var fills = fillEls();
      for (var i = 0; i < fills.length; i++) {
        var f = fills[i];
        f.style.transition = 'none';
        f.style.transform = 'scaleX(0)';
      }
      var active = fills[k];
      if (!active) return;
      void root.offsetWidth;
      active.style.transition = 'transform ' + durs[k] + 's linear';
      active.style.transform = 'scaleX(1)';
    }

    function scheduleNext(k) {
      if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
      autoTimer = setTimeout(function () {
        goTo((k + 1) % durs.length);
      }, durs[k] * 1000);
    }

    function goTo(k) {
      if (k < 0 || k >= durs.length) return;
      try {
        root.classList.add('is-manual');
        manualIndex = k;
        setActive(slideEls(), k);
        setActive(tabEls(), k);
        runFill(k);
        scheduleNext(k);
      } catch (err) {}
    }

    function step(dir) {
      // Before the first interaction the live position comes from the CSS clock; after
      // that we track it ourselves.
      var idx = (manualIndex >= 0) ? manualIndex : currentIndexNow();
      goTo(((idx + dir) % durs.length + durs.length) % durs.length);
    }

    // Tabs / progress segments stay delegated (there can be many, generated per slide).
    root.addEventListener('click', function (e) {
      var goto = e.target.closest ? e.target.closest('[data-hero-goto]') : null;
      if (goto && root.contains(goto)) {
        var k = parseInt(goto.getAttribute('data-hero-goto'), 10);
        if (!isNaN(k)) goTo(k);
      }
    });

    // Prev/next arrows: bound DIRECTLY on the buttons, not delegated, and on 'click',
    // 'pointerup', AND 'touchend' (with a short de-dupe window across all three). On some
    // mobile browsers a real tap on these two buttons was not reliably producing a 'click'
    // event that bubbled up to a single delegated listener on the root — most likely another
    // script upstream calling preventDefault() on the touch sequence, which suppresses the
    // browser's *synthesized* 'click' from a touch tap but does NOT suppress 'pointerup' or
    // 'touchend'. Listening directly on the button for all three event types is a strictly
    // more robust fallback regardless of the exact cause on a given device.
    function bindArrow(selector, dir) {
      var btn = root.querySelector(selector);
      if (!btn) return;
      var lastFire = 0;
      function fire(e) {
        var t = now();
        if (t - lastFire < 350) return; // de-dupe touchend/pointerup immediately followed by click
        lastFire = t;
        if (e && e.preventDefault) e.preventDefault();
        step(dir);
      }
      btn.addEventListener('click', fire);
      btn.addEventListener('pointerup', fire);
      btn.addEventListener('touchend', fire);
    }
    bindArrow('[data-hero-prev]', -1);
    bindArrow('[data-hero-next]', 1);

    // Swipe: the primary, most reliable way to move between slides on a real phone —
    // horizontal drag anywhere on the slide. Passive listeners (no preventDefault) so
    // normal vertical page scrolling is completely unaffected; only a clearly-horizontal
    // drag past a small threshold counts as a swipe.
    if (root.getAttribute('data-hero-swipe') === 'true') {
      var touchX = 0, touchY = 0, tracking = false, horizontal = false;
      root.addEventListener('touchstart', function (e) {
        if (!e.touches || e.touches.length !== 1) return;
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
        tracking = true;
        horizontal = false;
      }, { passive: true });
      root.addEventListener('touchmove', function (e) {
        if (!tracking || !e.touches || !e.touches[0]) return;
        var dx = e.touches[0].clientX - touchX;
        var dy = e.touches[0].clientY - touchY;
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) horizontal = true;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var touch = e.changedTouches && e.changedTouches[0];
        var dx = touch ? touch.clientX - touchX : 0;
        if (horizontal && Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      }, { passive: true });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-hero-slider]');
    for (var i = 0; i < roots.length; i++) {
      try { init(roots[i]); } catch (err) {}
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();